import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import QueenVideo from "./QueenVideo";
import "../../../styles/games/queen.css";
import BetTableQueen from "../../casinoComponents/betTableQueen";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import MyBet from "../../casinoComponents/myBet";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import ViewMoreModal from "../../../components/ViewMoreModal";
import {
  getCasinoGameDetails,
  getMatchExposure,
  getCasinoOpenBets,
} from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";


export default function Queen() {
  const [gameData, setGameData] = useState(null);
  const [subData, setSubData] = useState([]);
  const [iframeSrc, setIframeSrc] = useState("");
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);

  const { pathname } = useLocation();
  const gameName = extractCasinoGame(pathname) || "queen";

  useEffect(() => {
    setIframeSrc(
      `https://stream-s-43.uhdmovies.online/casino-stream?id=${gameName}`
    );

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(gameName);
        setGameData(response);
        setSubData(response?.data?.data?.sub || []);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const gameDataInterval = setInterval(fetchGameData, 1500);
    return () => clearInterval(gameDataInterval);
  }, [gameName]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId =
        gameData?.data?.data?.t1?.gmid?.toString() ||
        gameData?.data?.data?.mid?.toString() ||
        gameData?.data?.mid?.toString() ||
        gameData?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            const teamName =
              item.team_name || item.selection || item.player_name || "";
            const amount = parseFloat(item.exposure_amount) || 0;
            if (teamName) {
              exposureMap[teamName] = amount;
              exposureMap[teamName.toLowerCase()] = amount;
              exposureMap[teamName.trim()] = amount;
            }
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error("Error fetching exposure:", error);
    }
  }, [
    gameData?.data?.data?.t1?.gmid,
    gameData?.data?.data?.mid,
    gameData?.data?.mid,
    gameData?.mid,
  ]);

  const fetchMyBetsData = useCallback(async () => {
    if (!gameName) return;
    try {
      const response = await getCasinoOpenBets(gameName);
      if (response?.success && Array.isArray(response.data)) {
        setMyBets(response.data);
      }
    } catch (error) {
      console.error("Error fetching my bets:", error);
    }
  }, [gameName]);

  useEffect(() => {
    const matchId =
      gameData?.data?.data?.t1?.gmid?.toString() ||
      gameData?.data?.data?.mid?.toString() ||
      gameData?.data?.mid?.toString() ||
      gameData?.mid?.toString();

    if (matchId) {
      const t = setTimeout(() => fetchExposure(), 2000);
      const exposureInterval = setInterval(fetchExposure, 2000);
      return () => {
        clearTimeout(t);
        clearInterval(exposureInterval);
      };
    }
  }, [fetchExposure, gameData]);

  useEffect(() => {
    fetchMyBetsData();
    const intervalId = setInterval(fetchMyBetsData, 3000);
    return () => clearInterval(intervalId);
  }, [fetchMyBetsData]);

  const handleBetClick = () => {
    fetchExposure();
    fetchMyBetsData();
  };

  const resultData =
    gameData?.lrs ??
    gameData?.data?.data?.lrs ??
    gameData?.data?.lrs ??
    [];

  const roundId =
    gameData?.data?.data?.t1?.gmid ||
    gameData?.data?.data?.mid ||
    gameData?.data?.mid ||
    gameData?.mid ||
    "";

  // Reference: minimum/maximum stake from the first market (v-kvalmin / v-kvalmax, 1000 → K, 100000 → L)
  const kval = (n) => {
    const v = Number(Number(n || 0).toFixed(2));
    if (v >= 1e3 && v < 1e5) return `${parseFloat((v / 1e3).toFixed(2))}K`;
    if (v >= 1e5) return `${parseFloat((v / 1e5).toFixed(2))}L`;
    return parseFloat(v);
  };
  const casinoData = gameData?.data?.data;
  // Reference: markets = sub filtered by subtype "queen", ordered by sr
  const main = [...subData]
    .filter((s) => !s?.subtype || s.subtype === "queen")
    .sort((a, b) => (a?.sr ?? 0) - (b?.sr ?? 0));
  const remark = casinoData?.remark;

  return (
    <CasinoTableLayout
      tableClass="casino-queen"
      rightSide={
        <MyBet bets={myBets} onViewMore={() => setShowViewMoreModal(true)} />
      }
    >
      <>
        <QueenVideo
          title="Queen"
          roundId={casinoData?.mid ?? ""}
          iframeSrc={iframeSrc}
          timerValue={casinoData?.lt}
          cardString={casinoData?.card ?? casinoData?.t1?.card}
          subData={main}
        />{" "}
        {roundId ? (
          <div className="casino-detail">
            <BetTableQueen
              onBetClick={handleBetClick}
              data={main}
              exposures={exposures}
            />{" "}
            <div className="col-12 text-right casino-min-max">
              R:<span>{kval(main[0]?.min)}</span>-<span>{kval(main[0]?.max)}</span>
            </div>{" "}
            {remark ? (
              <div className="casino-remark mt-3">
                <div className="remark-icon">
                  <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} />
                </div>{" "}
                <marquee>{remark}</marquee>
              </div>
            ) : null}{" "}
            <CasinoLastResult
              gameType="queen"
              data={resultData}
              gameData={gameData}
            />
          </div>
        ) : null}
      </>
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={gameName}
      />
    </CasinoTableLayout>
  );
}
